import EFOcats_validates from '../../../core/v1/validate/efocats_validates.js';
import EFOcats_validate_char from './efocats_validate_char.js';
import EFOcats_validate_retro_password from './efocats_validate_retro_password.js';

/**
 * サラヤ用エラーチェッククラス
 */
export default class EFOcats_validates_retro extends EFOcats_validates {
  constructor() {
    super();

    // バリデーション追加
    this.char = new EFOcats_validate_char();
    this.password = new EFOcats_validate_retro_password();
  }

  check_error(elem) {
    let status_data = {status: 'success'};
    const validateList = this.set_validateList(elem);

    // エラーチェック
    for (let validateIndex = 0; validateIndex < validateList.length; validateIndex++) {
      const validate_id = validateList[validateIndex];
      if (this[validate_id]) {
        status_data = this[validate_id].validate(elem);
        if (status_data.status === 'error') {
          break;
        }
      }
    }

    if (status_data.status === 'success') {
      elem.removeClass('error-modifer');
      elem.parents('.check-flag').addClass('ok-flag');
      elem.parents('.check-flag').addClass('icon-flag');
      elem.parents('.message-flag').attr('data-error-text', '');

      const check_flag = elem.parents('.qa').find('.check-flag').length;
      const ok_flag = elem.parents('.qa').find('.ok-flag').length;

      if (check_flag === ok_flag) {
        elem.parents('.qa').addClass('go-flag');
      } else {
        elem.parents('.qa').removeClass('go-flag');
      }

      if (status_data.required === 'non-required') {
        elem.parents('.check-flag').addClass('ok-flag').removeClass('icon-flag');
      }
    } else {
      // エラー処理
      elem.parents('.qa').removeClass('go-flag');
      elem.addClass('error-modifer');
      elem.parents('.check-flag').removeClass('ok-flag');
      elem.parents('.check-flag').removeClass('icon-flag');

      // エラーテキスト表示
      elem.parents('.message-flag').attr('data-error-text', status_data.message);

      // 分析データ
      efocats.submit.error(status_data, elem);
    }

    if (status_data.status === 'error') {
      elem.parents('section').addClass('checked');
    }

    return status_data;
  }
}
